import { scaleVector2d, normalizeVector2d } from "./vector.js";
import seedrandom from "seedrandom";
import "../decorators/type.js";
import "ajv";
import "./clone.js";
import "bitecs";
import "./typehelpers.js";
import "../enums-86f58524.js";
import "../global-33d5eebf.js";
const DEFAULT_SEED = 9564394382908234;
const generate = (seedNumber) => {
  const rand = { call: seedrandom(seedNumber + "").quick };
  return {
    seedNumber,
    number: () => rand.call(),
    int: (min, max) => {
      if (max === void 0) {
        max = min;
        min = 0;
      }
      return Math.floor(rand.call() * (max - min + 1)) + min;
    }
  };
};
let _random = generate(DEFAULT_SEED);
const seed = (seedNumber) => {
  _random = generate(seedNumber);
};
const random = () => _random;
const randomPointOnARectangle = (random2, width, height) => {
  let p = random2.int(0, width + width + height + height);
  let x = 0;
  let y = 0;
  if (p < width + height) {
    if (p < width) {
      x = p;
      y = 0;
    } else {
      x = width;
      y = p - width;
    }
  } else {
    p = p - (width + height);
    if (p < width) {
      x = width - p;
      y = height;
    } else {
      x = 0;
      y = height - (p - width);
    }
  }
  return {
    x,
    y
  };
};
const randomPointInARectangle = (random2, width, height) => {
  const x = random2.int(0, width);
  const y = random2.int(0, height);
  return {
    x,
    y
  };
};
const randomPointInACircle = (random2, radius) => {
  const r = random2.number() * radius;
  const theta = random2.number() * Math.PI * 2;
  const x = r * Math.cos(theta);
  const y = r * Math.sin(theta);
  return {
    x,
    y
  };
};
const randomPointOnACircle = (random2, radius) => {
  return scaleVector2d(normalizeVector2d(randomPointInACircle(random2, radius)), radius);
};
export {
  generate,
  random,
  randomPointInACircle,
  randomPointInARectangle,
  randomPointOnACircle,
  randomPointOnARectangle,
  seed
};
//# sourceMappingURL=rand.js.map
